// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"styles_dropdown__d_t6r","newTag":"styles_newTag__Mn0He","dropdownElement":"styles_dropdownElement__d3n8Y"};